export const toastReducer = (state, action) => {
    switch (action.type) {
        case "ADD_TOAST":
            return {
                ...state,
                toasts: [...state.toasts, action.payload],
            };
        case "REMOVE_TOAST":
            return {
                ...state,
                toasts: state.toasts.filter(
                    (toast) => toast.id !== action.payload
                ),
            };
        case "CLEAR_ALL_TOASTS":
            return {
                ...state,
                toasts: [],
            };
        default:
            return state;
    }
};

// Initial state
export const toastInitialState = {
    toasts: [],
};
